import React, { useState } from "react";
import "./Header.css";
import logo from "../assets/headerlogo.png"; // Import image
import { Link } from "react-router-dom";

export const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="logo"><img src={logo} alt="Logo" /></div>
      <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? "✖" : "☰"} {/* Toggle between open and close icon */}
      </button>
      <nav className={menuOpen ? "nav open" : "nav"}>
      <ul>
      <li><Link to="/">HOME</Link></li>
      <li><Link to="/about">ABOUT US</Link></li>

      {/* Submenu Section */}
      <li className="submenu-container">
  <span className="nav-link" onClick={() => setSubmenuOpen(!submenuOpen)}>
    SERVICES ▾
  </span>
  <ul className={submenuOpen ? "submenu open" : "submenu"}>
    <li><Link to="/services/individual">INDIVIDUAL</Link></li>
    <li><Link to="/services/child">CHILD</Link></li>
    <li><Link to="/services/couple">COUPLE</Link></li>
  </ul>
</li>

      <li><Link to="/contact">CONTACT US</Link></li>
    </ul>
      </nav>
    </header>
  );
};
